(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mw-image-archive"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('matagi-archive'))customElements.define('matagi-archive',class extends HTMLElement{
  connectedCallback(){
    if(this.dataset.ready)return;
    this.dataset.ready='true';
    this.links=Array.from(this.querySelectorAll('[data-archive-image]'));
    this.dialog=this.querySelector('dialog');
    this.stage=this.querySelector('[data-archive-stage]');
    this.counter=this.querySelector('[data-archive-counter]');
    this.current=0;
    this.links.forEach((link,index)=>link.addEventListener('click',event=>{
      if(event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||!this.dialog.showModal)return;
      event.preventDefault();this.opener=link;this.show(index);this.dialog.showModal();document.documentElement.classList.add('mp-archive-open');
    }));
    this.querySelector('[data-archive-close]').addEventListener('click',()=>this.dialog.close());
    this.querySelectorAll('[data-archive-step]').forEach(button=>button.addEventListener('click',()=>this.show(this.current+Number(button.dataset.archiveStep))));
    this.querySelectorAll('[data-archive-scroll]').forEach(button=>button.addEventListener('click',()=>{
      const grid=this.querySelector('.mp-archive-grid');const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches||document.documentElement.dataset.lvMotion==='off';
      grid.scrollBy({left:grid.clientWidth*Number(button.dataset.archiveScroll),behavior:reduced?'instant':'smooth'});
    }));
    this.dialog.addEventListener('click',event=>{if(event.target===this.dialog)this.dialog.close()});
    this.dialog.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();this.show(this.current+(event.key==='ArrowLeft'?-1:1))}});
    this.dialog.addEventListener('close',()=>{document.documentElement.classList.remove('mp-archive-open');this.stage.replaceChildren();this.opener?.focus({preventScroll:true})});
  }
  show(index){
    this.current=(index+this.links.length)%this.links.length;const link=this.links[this.current],thumbnail=link.querySelector('img'),photo=new Image(),detail=new Image(),requestId=(this.loadId||0)+1;this.loadId=requestId;
    photo.alt=link.dataset.alt||'';photo.src=thumbnail.currentSrc||thumbnail.src;detail.alt=photo.alt;
    this.stage.replaceChildren(photo);this.counter.textContent=this.dataset.countLabel+' '+String(this.current+1).padStart(2,'0')+' / '+String(this.links.length).padStart(2,'0');
    detail.onload=()=>{if(this.loadId===requestId&&this.dialog.open)this.stage.replaceChildren(detail)};detail.src=link.href;
  }
  disconnectedCallback(){if(this.dialog?.open){this.dialog.close();document.documentElement.classList.remove('mp-archive-open')}}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mw-observatory"] && !Shopify.designMode) return;
  try {
    (() => {
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  function prepare(scope) {
    scope.querySelectorAll('[data-ml-instrument]').forEach(host => {
      if (host.dataset.mlReady) return;
      host.dataset.mlReady = 'true';
      const stage = host.querySelector('.ml-instrument-stage');
      const points = [...host.querySelectorAll('[data-ml-point]')];
      const heading = host.querySelector('[data-ml-heading]');
      const copy = host.querySelector('[data-ml-copy]');
      const reset = host.querySelector('[data-ml-reset]');
      const guide = host.querySelector('[data-ml-guide]');
      let selected = null, frame = 0, x = 0, y = 0;
      const allowed = () => fine.matches && !reduce.matches && document.documentElement.dataset.lvMotion !== 'off' && !document.hidden;
      function select(point) {
        if (point === selected) return;
        selected = point;
        const source = host.querySelector(point ? '[data-ml-content="' + point.dataset.mlPoint + '"]' : '[data-ml-default]').content;
        heading.textContent = source.querySelector('strong').textContent;
        copy.textContent = source.querySelector('p').textContent;
        host.toggleAttribute('data-inspecting', Boolean(point));
        points.forEach(button => button.setAttribute('aria-pressed', String(button === point)));
        host.querySelector('[data-ml-index]').textContent = point ? String(Number(point.dataset.mlPoint) + 1).padStart(2, '0') : '00';
        host.querySelector('[data-ml-zoom]').textContent = point ? '3' : '1';
        if (!point) return;
        const markerX = Number(point.dataset.x), markerY = Number(point.dataset.y);
        const px = Number(point.dataset.focusX ?? point.dataset.x), py = Number(point.dataset.focusY ?? point.dataset.y);
        host.style.setProperty('--inspect-x', px + '%');
        host.style.setProperty('--inspect-y', py + '%');
        host.style.setProperty('--detail-x', ((px - 6) / .88) + '%');
        host.style.setProperty('--detail-y', ((py - 6) / .88) + '%');
        guide.setAttribute('d', markerX === px && markerY === py ? 'M' + px + ' ' + (py + 4) + 'V92H20V100' : 'M' + markerX + ' ' + markerY + 'L' + px + ' ' + py + 'V92H20V100');
      }
      points.forEach(button => {
        button.addEventListener('pointerenter', event => { if (fine.matches && event.pointerType !== 'touch') select(button); });
        button.addEventListener('focus', () => select(button));
        button.addEventListener('click', () => select(button));
      });
      reset.addEventListener('click', () => select(null));
      host.addEventListener('keydown', event => { if (event.key === 'Escape') { select(null); reset.focus(); } });
      function neutral() {
        cancelAnimationFrame(frame); frame = 0;
        stage.style.removeProperty('--inspect-dx'); stage.style.removeProperty('--inspect-dy'); stage.style.removeProperty('--inspect-angle');
      }
      function paint() {
        frame = 0;
        if (!host.isConnected || !allowed()) return;
        const rect = stage.getBoundingClientRect();
        const px = Math.max(-.5, Math.min(.5, (x - rect.left) / rect.width - .5));
        const py = Math.max(-.5, Math.min(.5, (y - rect.top) / rect.height - .5));
        stage.style.setProperty('--inspect-dx', (px * 5).toFixed(2) + 'px');
        stage.style.setProperty('--inspect-dy', (py * 5).toFixed(2) + 'px');
        stage.style.setProperty('--inspect-angle', (px * 25).toFixed(2) + 'deg');
      }
      stage.addEventListener('pointermove', event => {
        if (!allowed()) return;
        x = event.clientX; y = event.clientY;
        if (!frame) frame = requestAnimationFrame(paint);
      }, {passive: true});
      stage.addEventListener('pointerleave', neutral);
      stage.addEventListener('pointercancel', neutral);
      const onVisibility = () => { if (document.hidden) neutral(); };
      document.addEventListener('visibilitychange', onVisibility);
      reduce.addEventListener('change', neutral);
      const observer = new MutationObserver(() => { if (!allowed()) neutral(); });
      observer.observe(document.documentElement, {attributes: true, attributeFilter: ['data-lv-motion']});
      const unload = event => {
        if (!event.target.contains(host)) return;
        neutral(); observer.disconnect(); reduce.removeEventListener('change', neutral);
        document.removeEventListener('visibilitychange', onVisibility);
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => prepare(document), {once: true});
  else prepare(document);
  document.addEventListener('shopify:section:load', event => prepare(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mw-sentinel-view"] && !Shopify.designMode) return;
  try {
    (() => {
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  function prepare(scope) {
    scope.querySelectorAll('[data-mw-sentinel]').forEach(figure => {
      if (figure.dataset.sentinelReady) return;
      figure.dataset.sentinelReady = 'true';
      const front = figure.querySelector('.mw-sentinel-front');
      const back = figure.querySelector('.mw-sentinel-back');
      const button = figure.querySelector('.mw-sentinel-toggle');
      const label = button.querySelector('span');
      let requested = false;
      function render() {
        const ready = back.complete && back.naturalWidth > 0;
        const active = ready && requested;
        figure.toggleAttribute('data-back', active);
        front.setAttribute('aria-hidden', String(active));
        back.setAttribute('aria-hidden', String(!active));
        button.hidden = !ready;
        label.textContent = active ? button.dataset.showFront : button.dataset.showBack;
      }
      function show(active) { requested = active; render(); }
      back.addEventListener('load', render);
      back.addEventListener('error', () => show(false));
      figure.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse' && fine.matches) show(true);
      });
      figure.addEventListener('pointerleave', event => {
        if (event.pointerType === 'mouse' && fine.matches && !button.matches(':focus-visible')) show(false);
      });
      button.addEventListener('click', () => show(!figure.hasAttribute('data-back')));
      button.addEventListener('keydown', event => {
        if (event.key === 'Escape') { show(false); event.preventDefault(); }
      });
      render();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => prepare(document));
  else prepare(document);
  document.addEventListener('shopify:section:load', event => prepare(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
